import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 全局引入elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 全局引入基础组件-列表组件+搜索
import basicList from "@/components/basicList";
import pageTitle from "@/components/pageTitle";
Vue.component('basicList', basicList)
Vue.component('pageTitle', pageTitle)

import MyPlugin from './utils/customMethod.js';
Vue.use(MyPlugin);

import Print from './assets/print';
Vue.use(Print);
Vue.prototype.$print = Print;


import clearZero from './utils/clearZero.js';
Vue.directive('clear-zero', clearZero);


import htmlToPdf from '@/utils/htmlToPdf'
Vue.use(htmlToPdf)

import {
  getRoles,
} from "@/utils";

// 金额过滤器，保存两位小数
Vue.filter('money', function (value) {
  if (!value && value != 0) {
    return '--';
  } else if (value == 0) {
    return '0.00';
  } else {
    return parseFloat(value / 100).toFixed(2);
  }
});

//在路由跳转前进行判断
router.beforeEach((to, from, next) => {

  const roleId = store.getters.userRole; // 从 Vuex 获取用户角色

  //设置直接通过的路由地址
  if (to.path === "/login" || to.path === "/storeLargeScreen" || to.path === "/logisticsCode" || to.path === "/SY" || to.path == '/bigDataScreen') {
    next();
  } else {
    const tokenStr = getRoles(); //Cookie.get('roles')
    if (!tokenStr) {
      return next("/login");
    } else {
      return next();
      // if (to.meta.roles.length === 0) {
      //   next()
      // } else {
      //   for (let i = 0; i < to.meta.roles.length; i++) {
      //     if (tokenStr.includes(to.meta.roles[i])) {
      //       next()
      //     }
      //   }
      // }
    }
  }
})

// 监视 Vuex 中角色的变化；店员菜单，另外控制
store.watch(
  (state) => [state.user.roleId, state.user.userMenuList],
  ([newRoleId, newUserMenuList], [oldRoleId, oldUserMenuList]) => {
    // 非员工依据角色来判断菜单
    if (newRoleId != 4) {
      setRouteVisibility(router.options.routes, newRoleId)

      // 员工依据员工菜单表来判断菜单
    } else {
      setRouteVisibilityByMenu(router.options.routes, newUserMenuList)
    }
  }
);

// 递归函数，高级别用户，依据角色判断路由
function setRouteVisibility(routes, newRole) {
  routes.forEach(route => {
    // 判断当前路由的权限
    if (!!route.meta && !!route.meta.roles) {
      route.hidden = !route.meta.roles.includes(newRole);
    } else {
      route.hidden = true; // 如果没有定义角色，默认隐藏
    }
    // 检查是否有子路由并递归
    if (route.children && route.children.length > 0) {
      setRouteVisibility(route.children, newRole); // 递归调用
    }
  });
}

// 递归函数，普通用户，依据角色菜单表判断路由
function setRouteVisibilityByMenu(routes, menuList) {
  routes.forEach(route => {
    let metaMenu = !!route.meta.menu ? route.meta.menu : route.meta.title
    Vue.set(route, 'hidden', !menuList.includes(metaMenu));
    // 检查是否有子路由并递归
    if (route.children && route.children.length > 0) {
      setRouteVisibilityByMenu(route.children, menuList);
    }
  });
}

// 全局css引入
import '@/assets/css/public.css'
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>',
  created() {
    // 在 Vue 实例被创建之后，立即调用 Vuex action 来恢复用户数据
    this.$store.dispatch('restoreUserData');
  }
})



// WEBPACK FOOTER //
// ./src/main.js